import { Injectable } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '@services/Logic/storage.service';
import { UserSettingsService } from '@services/http/userSettings.service';

@Injectable()
export class NavigationService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userSettingsService: UserSettingsService,
  ) {}

  /**
   * Reload the page without changing location.
   */
  onAuthNavigation() {
    const userRole =
      this.storage?.userSettings?.pinployeeOrTaskOwner ??
      this.storage.user.pinployeeOrTaskOwner;
    if (!userRole) {
      this.userSettingsService
        .getSettings()
        .subscribe((res) => this.navigateToPath(res.pinployeeOrTaskOwner));
    } else {
      return this.navigateToPath(userRole);
    }
  }

  navigateToPath(userRole: string) {
    const params = this.route.snapshot.queryParams;
    const currentRoute = this.router.url;
    let route;
    if (userRole === 'to' || userRole === 'both') {
      route = '/udforsk';
    } else if (userRole === 'pp') {
      route = '/opgaver';
    }
    // Exclude Task Page
    if (params.taskId !== undefined) {
      return this.router
        .navigateByUrl(currentRoute, { skipLocationChange: true })
        .then(() => {});
    }
    return this.router.navigate([route]);
  }
}
